import { Keyboard } from '@lightningjs/ui';
import { Lightning as lng } from '@lightningjs/sdk';
import { generateConfig } from './helpers/ConfigGenerator';
import { defaultOptions } from './helpers/defaultOptions';

export class OnScreenKeyboard extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      texture: lng.Tools.getRoundRect(800, 240, 10, 3),
      color: 0xff617075,
      Keyboard: {
        x: 16,
        y: 16,
        type: Keyboard,
        navigationWrapAround: true,
        backSpaceRemovesLetters: false,
        config: generateConfig(defaultOptions),
        currentLayout: 'abc',
        signals: { onLayout: true },
        passSignals: { onFinished: true, onInputChanged: true },
      },
    };
  }

  _construct() {
    this._conf = defaultOptions;
  }

  _getFocused() {
    return this.tag('Keyboard');
  }

  _firstActive() {
    this.tag('Keyboard')._update();
  }

  set config(val) {
    this._conf = val;
    this.tag('Keyboard').config = generateConfig(val);
    this.fixSizes(this.tag('Keyboard').config);
    if (this.active) {
      this.tag('Keyboard')._update();
    }
  }

  get config() {
    return this._conf;
  }

  set inputField(field) {
    this.tag('Keyboard').inputField(field);
  }

  set currentLayout(layout) {
    this.tag('Keyboard').currentLayout = layout;
  }

  set maxCharacters(num) {
    this.tag('Keyboard').maxCharacters = num;
  }

  onLayout() {
    this.fixSizes(this.tag('Keyboard').config);
  }

  // the lib keyboard has no finalW for some reason..
  // additionally, the keyboard does not accept a w => w as width
  // manually calculate the width and positioning and fix this width and positioning
  fixSizes(keyboardConfig, toLayout) {
    let BGPADDING = 16;

    let currentLayout = toLayout || this.tag('Keyboard').currentLayout;
    let maxlen = -1;
    keyboardConfig.layouts[currentLayout].forEach(x => {
      maxlen = Math.max(maxlen, x.length);
    });
    let keywidth = keyboardConfig.buttonTypes.default.w;
    let keyHeight = keyboardConfig.buttonTypes.default.h;
    let hSpacing = keyboardConfig.styling.horizontalSpacing || 0;
    let vSpacing = keyboardConfig.styling.verticalSpacing || 0;
    let kbwidth = (keywidth + hSpacing) * maxlen;
    let kbheight = (keyHeight + vSpacing) * keyboardConfig.layouts[currentLayout].length;
    this.w = kbwidth + BGPADDING * 2;
    this.h = kbheight + BGPADDING * 2;
    this.tag('Keyboard').patch({
      w: kbwidth,
      h: kbheight,
      x: BGPADDING,
      y: BGPADDING,
    });
  }

  _handleDown() {
    return true;
  }

  _handleUp() {
    return true;
  }
}
